<div *ngIf="!(loadingSubject | async) else loading"
     id="myCity"
     class="my-city">

    <iframe class="my-city__iframe"
            [src]="myCityUrl"
            frameborder="0">
    </iframe>

</div>

<ng-template #loading>

    <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
    </div>

</ng-template>